
;(function ($) {
    const $body = $(document.body);
    const $root = $('#violations-root');
    const catalog = $root.data('catalog')
    const $catalogModal = $('.js-catalog-modal');
    const $violationsList = $('.js-violations-list');
    const $inputsContainer = $('.js-violations-inputs');
    const templates = {};

    $('template[data-report-template]').each(function () {
        templates[$(this).attr('data-report-template')] = $(this).html();
    });

    let violations = [];

    const escapeHtml = s => String(s || '').replace(/[&<>"']/g, m => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
    }[m]));
    const uniqueId = () => 'v_' + Math.random().toString(36).slice(2, 9);
    const extractManual = s => String(s || '').replace(/_manual$/i, '');

    // ---------- Каталог ----------
    $body.on('click', '.js-open-catalog', () => {$catalogModal.addClass('is-active'); $('body').css('overflow','hidden')});
    $body.on('click', '.js-close-catalog', () => {$catalogModal.removeClass('is-active'); $('body').css('overflow','')});

    // поиск по названию
    $body.on('input', '.js-catalog-search', function () {
        const val = $(this).val().toLowerCase();
        $('.js-catalog-list .js-catalog-item').each(function () {
            const title = $(this).text().toLowerCase();
            $(this).closest('li').toggle(title.includes(val));
        });
    });

    $body.on('click', '.js-catalog-item', function () {
        const id = $(this).data('report-id');
        const title = $(this).data('report-title');
        const fields = catalog[id].fields
        if(!fields || fields.length === 0 || !Object.keys(fields).length) {
            applyingChoice(id, title);
            return;
        }

        openModal(id, title);
    });

    // ---------- Модалки нарушений ----------
    function openModal(reportId, title, editIndex = null) {
        const tplHtml = templates[reportId];
        if (!tplHtml) return;

        const $modal = $(tplHtml);

        $('body').append($modal);

        // если редактируем — подставить значения
        if (editIndex !== null) {
            const params = violations[editIndex].params;
            for (const k in params) {
                const $el = $modal.find(`[name="${k}"], [id="${k}"]`);
                const val = params[k];
                if ($el.is(':checkbox')) $el.prop('checked', !!val);
                else $el.val(val);
                if(/_manual$/i.test(k)) $el.show();

            }
        }

        // закрытие
        $modal.on('click', '.js-close-report', () => $modal.remove());

        // сохранить
        $modal.on('click', '.js-save-report', () => {
            const params = {};
            $modal.find('input,select,textarea').each(function () {
                const n = $(this).attr('name') || $(this).attr('id');
                if (!n) return;
                if ($(this).hasClass('manual-input-field')) {
                    const $select = $(this).data('linked-select');
                    if ($select && $select.val() === 'manual_input') {
                        params[n] = $(this).val();
                    }
                } else {
                    params[n] = $(this).is(':checkbox') ? $(this).is(':checked') : $(this).val();
                }
            });

            applyingChoice(reportId, title, editIndex, params)
            $modal.remove();
        });

        // добавляем выбор зависимых опций
        addDepends($modal)
        // добавляем обработчики для полей ручного ввода
        addManualInputHandlers($modal);
    }
    function addManualInputHandlers($modal) {
        if ($modal.length === 0) return;

        $modal.find('select').each(function() {
            const $select = $(this);
            const selectName = $select.attr('name') || $select.attr('id');

            let $manualInput = $modal.find('[name="' + selectName + '_manual"]');

            if ($manualInput.length === 0) {
                $manualInput = $(`
                    <input type="text"
                           name="${selectName}_manual"
                           class="form-input manual-input-field"
                           style="display: none; margin-top: 5px;"
                           placeholder="Введите значение вручную">
                `);
                $select.after($manualInput);
            }

            $manualInput.data('linked-select', $select);

            $select.on('change', function() {
                if ($(this).val() === 'manual_input') {
                    $manualInput.show().focus();
                } else {
                    $manualInput.hide().val('');
                }
            });

            if ($select.val() === 'manual_input') {
                $manualInput.show();
            }
        });
    }

    // Подтверждаем выбор, закрывает модалку, рендерим список
    function applyingChoice(reportId, title, editIndex = null, params = []){
        const instanceId = uniqueId();
        const item = {instanceId: instanceId, report_id: reportId, title, params};

        if (editIndex !== null) violations[editIndex] = item; else violations.push(item);

        renderList();

        $catalogModal.removeClass('is-active');
        $('body').css('overflow','');
    }

    // ---------- Рендер списка ----------
    function renderList(disabled = false) {
        $violationsList.empty();
        $inputsContainer.empty();

        violations.forEach((v, i) => {
            const summary = Object.entries(v.params)
                .filter(([k, val]) => {
                    if(/_manual$/i.test(k) && val.length === 0) return false
                    if(val === 'manual_input') return false

                    return true;
                })
                .slice(0, 3)
                .map(([k, val]) => {
                    if(!k || !val) return;
                    const reportId = escapeHtml(v.report_id);
                    const fieldId = extractManual(escapeHtml(k));
                    const extractedManual = fieldId !== escapeHtml(k)
                    const fieldCatalog = catalog[reportId].fields[fieldId];
                    const label = escapeHtml(fieldCatalog.label);
                    const value = extractedManual
                        ? escapeHtml(val)
                        : getCatalogValue(reportId, fieldId, val);

                    return `<div><span>${label}</span><span>${value}</span></div>`;
                }).join('');
            const canEdit = summary.length > 0;

            const $li = $(`
                <li class="act-info__violation" data-idx="${i}">
                  <div class="act-info__violation-header">
                    <span class="act-info__violation-title">${escapeHtml(v.title)}</span>
                    <div class="act-info__violation-actions">
                      ${canEdit
                        ? `<button type="button" class="btn btn--default btn--icon-edit js-edit" ${disabled ? 'disabled' : ''}><span class="btn-label btn-icon">Редактировать</span></button>`
                        : ''
                      }
                      <button type="button" class="btn btn--default btn--icon-remove js-del" ${disabled ? 'disabled' : ''}><span class="btn-label btn-icon">Удалить</span></button>
                    </div>
                  </div>
                  <div class="act-info__violation-preview">${summary}</div>
                </li>
            `);
            $violationsList.append($li);

            // inputs для отправки
            const $wrap = $('<div/>');
            $wrap.append(`<input type="hidden" name="violations[${i}][report_id]" value="${v.report_id}">`);
            for (const k in v.params) {
                const val = v.params[k];
                $wrap.append(`<input type="hidden" name="violations[${i}][params][${k}]" value="${escapeHtml(val)}">`);
            }
            $inputsContainer.append($wrap);
        });
    }

    // в окне с выбором параметров вешаем зависимости, определенные в конфиге
    function addDepends($modal){
        if($modal.length === 0) return

        const modal = $modal.get(0);

        // Находим все input, у которых есть атрибут data-depends-on
        modal.querySelectorAll('input[data-depends-on]').forEach(input => {
            const dependsOn = input.dataset.dependsOn; // получаем id select
            if (!dependsOn) return;

            const select = modal.querySelector(`[name='${dependsOn}']`);
            if (!select) return;

            select.addEventListener('change', e => {
                const selectedOption = select.selectedOptions[0];
                if (!selectedOption) {
                    input.value = '';
                    return;
                }

                // У зависимого объекта select name должен начинаться с name объекта зависимости input
                const inputName = input.name
                const selectName = select.name
                let dataAttr = '';
                if (inputName.startsWith(selectName + '_')) {
                    // Берем оставшуюся часть, отсекаем разделитель
                    dataAttr = inputName.slice(selectName.length + 1);
                }
                // внутри select есть options, у которых должны быть датасеты с оставшейся частью отсеченного имени input
                let dataAttrValue = selectedOption.dataset[dataAttr];
                if (!dataAttrValue) {
                    input.value = '';
                    return;
                }
                // Убираем лишние символы
                dataAttrValue = dataAttrValue.replace(/^['"]|['"]$/g, '');
                // Вставляем зависимое значение в input
                input.value = dataAttrValue;
            });
        });
    }

    // получение значения из справочника
    function getCatalogValue(reportId, fieldId, valueId){
        const report = catalog[reportId];
        const field = report.fields[fieldId];

        if(field.type === 'select'){
            return field.value[valueId] ?? '';
        }

        if(field.type === 'date'){
            const d = new Date(valueId);
            return d.toLocaleDateString('ru-RU');
        }

        return valueId;
    }

    // ---------- Действия ----------
    $body.on('click', '.js-edit', function () {
        openModal(violations[$(this).closest('li').data('idx')].report_id,
            violations[$(this).closest('li').data('idx')].title,
            $(this).closest('li').data('idx'));
    });
    $body.on('click', '.js-del', function () {
        violations.splice($(this).closest('li').data('idx'), 1);
        renderList();
    });

    // ---------- init ----------
    $(function () {
        const selected = $root.data('selected');
        (selected || []).forEach(v => violations.push(v));
        renderList(true);
    });

})(jQuery);
